// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5d57f5d0","817":"a7743a84"}[chunkId] + ".chunk.js";
};